module.exports = __webpack_public_path__ + "img/role.ea969e8f.svg";